import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { TextField, withStyles, Button, CircularProgress, DialogContentText, Typography, InputLabel, MenuItem, Select, FormControl } from "@material-ui/core";
import { hasPermission } from '../../sc-utilities';

const styles = theme => ({
    btn: { width: '40%', marginRight: '20%' },
    formControl: {
        marginTop: theme.spacing(5),
        width: "100%",
        marginBottom: '5px',
    },
    noType: { marginBottom: theme.spacing(5), },
    dialogPaper: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        minHeight: '10vh',
        minWidth: '70vh'
    },
    submit: {
        width: "40%",
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
});

const TableViewForm = (props) => {
    const { classes, formSettings, initialValues, permissions, handleOpenClose, handleSubmit, translations } = props;

    const types = [{value:"system", label:'System'}, {value:'customer', label:'Customer'}]
    return (
        <Formik

            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
                setSubmitting(false);
                handleOpenClose();
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                return (

                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(values) }}>
                         <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                        {hasPermission(permissions, 'system_table_view_create') ? <FormControl className={classes.formControl} margin={"dense"} >
                            <InputLabel shrink>{translations["table_view_type_select"] || "Please select view type"}</InputLabel>
                            <Select
                                name="type"
                                label={translations["table_view_type"] || 'Table View type'}
                                margin={"dense"}
                                value={values.type || ''}
                                onChange={handleChange}
                            >
                                {(types ? types : []).map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {translations[option.value] || option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> : null}
                        <DialogContentText>
                            {translations['choose_name'] || 'Please choose name for table view.'}
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            className={!hasPermission(permissions, 'table_view_create') ? classes.noType : null}
                            value={values.Name}
                            name="Name"
                            onBlur={handleBlur}
                            error={!!(errors.Name && touched.Name)}
                            label={translations['name'] || "Name"}
                            onChange={handleChange}
                            type="text"
                            fullWidth />
                        <div>
                            {formSettings.ButtonCancel ? (
                                <Button
                                    className={classes.btn}
                                    variant="contained"
                                    color={formSettings.ButtonCancel.Color}
                                    onClick={formSettings.ButtonCancel.handleCancel}
                                >{formSettings.ButtonCancel.Title}
                                </Button>
                            ) : null}
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    color={formSettings.ButtonSubmit.Color}
                                    variant="contained"
                                    type="submit"
                                    disabled={isSubmitting || !(isValid && dirty)}
                                >
                                    {(isSubmitting) ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}

                        </div>
                    </form>
                );
            }}
        </Formik>
    );
}

export default withStyles(styles, { withTheme: true })(TableViewForm);

